import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { hoursDifferenceFromUtcNow } from '@era/core';
import { Device } from '@era/locations-sdk';
import { OsUpdateStatusState } from '@era/osupdates-sdk';
import { RoomNumberComponent } from './room-number.container';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DevicesOsUpdateStatusStates } from '../../sub-features/device-os-updates/devices-os-update-statuses-store';

@Component({
  selector: 'era-device-grid-item-ui',
  templateUrl: './device-grid-item.component.html',
  styleUrls: ['./device-grid-item.component.scss'],
  imports: [RoomNumberComponent, FaIconComponent, NgbTooltip, DatePipe],
})
export class DeviceGridItemComponent implements OnChanges {
  @Input() public device: Device;
  @Input() public isSelected: boolean;
  @Input() public hasWarning: boolean;
  @Input() public osUpdateStatus: DevicesOsUpdateStatusStates.OSUpdateStatus;
  @Input() public isApplicationInSync: boolean;
  @Input() public isInUse: boolean;

  osUpdateStatusState = OsUpdateStatusState;

  private _isOver24Hours: boolean;
  private _isOver48Hours: boolean;

  public get isOver24Hours(): boolean {
    return this._isOver24Hours;
  }

  public get isOver48Hours(): boolean {
    return this._isOver48Hours;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.device) {
      this._isOver24Hours = hoursDifferenceFromUtcNow(new Date(this.device.lastSeen)) > 24;
      this._isOver48Hours = hoursDifferenceFromUtcNow(new Date(this.device.lastSeen)) > 48;
    }
  }
}
